export default __webpack_public_path__ + "static/media/flag-es-US.5db19c75.png";